"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemplateNames = void 0;
var TemplateNames;
(function (TemplateNames) {
    TemplateNames["QUICK_FOLLOWUP"] = "QuickFollowup";
    TemplateNames["QUICK_FOLLOWUP_REGISTRATION"] = "QuickFollowupRegistration";
    TemplateNames["QUICK_FOLLOWUP_REGISTRATION_2"] = "QuickFollowupRegistration2";
    TemplateNames["ACCOUNT_APPROVED"] = "AccountApproved";
    TemplateNames["FENA_CHEAT_SHEET"] = "FenaCheatSheet";
    TemplateNames["GETTING_ON_INTEGRATION"] = "GettingOnIntegration";
    TemplateNames["LOG_BACK_TO_YOUR_FENA"] = "LogBackToYourFena";
    TemplateNames["OPEN_BANKING_PAYMENTS"] = "OpenBankingPayments";
    TemplateNames["SIGNING_UP_FOR_FENA"] = "SigningUpForFena";
    TemplateNames["STARTED_REGISTRATION"] = "StartedRegistration";
    TemplateNames["THANK_YOU"] = "ThankYou";
    TemplateNames["TRANSACTION_SUSPENSION"] = "TransactionSuspension";
    TemplateNames["WELCOME_ABOARD"] = "WelcomeAboard";
})(TemplateNames = exports.TemplateNames || (exports.TemplateNames = {}));
